import { withPrefix as gatsbyWithPrefix } from 'gatsby';

export const withPrefix = (src: string, withPrefixFn = gatsbyWithPrefix) => {
  const pathPrefix = `/${process.env.path_prefix}`;

  if (src.startsWith(pathPrefix)) {
    return src;
  }

  return withPrefixFn(src);
};
